// ============================================================
// ScrollTopButton
// ------------------------------------------------------------
// ปุ่มลอย "กดเพื่อไปยังด้านบน" มุมขวาล่าง โผล่เมื่อเลื่อนหน้าลงเกิน 300px
// เดิม copy อยู่ 4 หน้า (ImportCustomer, ImportBillWater, ImportBillUnitUsed, Report)
// พร้อม state visible + event listener ของตัวเอง
//
// ใช้: วาง <ScrollTopButton /> ไว้ท้าย render ของหน้าจอ
// ============================================================

import React, { Component } from "react";

// เลื่อนลงเกินกี่ pixel ถึงจะโชว์ปุ่ม
const SHOW_AFTER = 300;

export default class ScrollTopButton extends Component {
  state = { visible: false };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const visible = window.pageYOffset > SHOW_AFTER;
    if (visible !== this.state.visible) this.setState({ visible });
  };

  render() {
    if (!this.state.visible) return null;
    return (
      <button className="position-fixed btn btn-primary" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} style={{ bottom: 30, right: 30, zIndex: 100 }}>
        กดเพื่อไปยังด้านบน
      </button>
    );
  }
}
